module.exports = __webpack_public_path__ + "img/pistone_buss_fristilt.ee683934.png";